<template>
    <div class="validate-account container">
        <GoToBack />
        <div class="validate-account-content">
            <h1 class="v-content-merchant-validateaccount" v-contentMerchantValidateaccount="{ section: 'Form', removeHtml: true }">Validação da conta</h1>
            <h3 class="v-content-merchant-validateaccount" v-contentMerchantValidateaccount="{ section: 'Form', removeHtml: true }">Introduza o código enviado por sms para seu número</h3>
            <form @submit.prevent="validateAccount()">
                <div class="form-group">
                    <label for="code" class=" code v-content-merchant-validateaccount" v-contentMerchantValidateaccount="{ section: 'Form', removeHtml: true }">Código SMS</label>
                    <input type="text" id="code" name="code" placeholder="" v-model="code"  @keypress="onlyNumbers" required maxlength="9">
                </div>
                <button type="submit">Criar conta</button>
            </form>
        </div>
    </div>
</template>

<script>
import GoToBack from '@/components/buttons/GoToBack.vue'
import axios from 'axios';
import store from "@/store";
import { mapState } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
    data() {
        return {
            code: ''
        }
    },
    components: {
        GoToBack
    },
    computed: {
        ...mapState('App', ['loading']),
    },
    methods: {
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        },
        async validateAccount() {
            store.dispatch('App/loading', true);
            try {
                const response = await axios.post('/api/v1/user/validate-code', {
                    code: this.code,
                    hash: localStorage.getItem('hash'),
                    lang: lang
                });
                
                store.dispatch('App/loading', false);

                if (response.data.success) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: response.data.message,
                        timer: 5000,
                    });
                    this.$router.push('/datos-del-cliente');
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: response.data.error.message,
                        timer: 5000,
                    });
                }
            } catch (error) {
                console.error(error);
                store.dispatch('App/loading', false);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: error,
                    timer: 5000,
                });
            }
        },
        updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-merchant-validateaccount');
            allContents.splice(0, allContents.length); // clear the contents array
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
        contentMerchantValidateaccount: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-merchant-validateaccount');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-merchant-validateaccount');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    }
}
</script>

<style lang="scss" scoped>
.validate-account {
    padding: 150px 15px 200px;
    &-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: 35px;
        @media screen and (max-width: 768px) {
            height: auto;
            gap: 50px;
        }

        h1 {
            font-size: 35px;
            font-family: 'Font Bold';
            color: #E84E0F;
            text-align: left;
        }

        h3 {
            font-size: 25px;
            color: #000;
            font-family: 'Font Regular';
            text-align: left;
        }

        form {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            width: 100%;
            @media screen and (max-width: 768px) {
                gap: 50px;
                align-items: center;
            }

            .form-group {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                @media screen and (max-width: 768px) {
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                }
                .code {
                    margin-right: 150px;
                }

                label {
                    font-size: 16px;
                    font-family: 'Font Medium';
                    margin-bottom: 5px;
                    text-align: left;
                    max-width: 80%;
                    @media screen and (max-width: 768px) {
                        margin-right: 0;
                    }
                }

                input[type="text"] {
                    height: 50px;
                    width: 398px;
                    flex: 1;
                    padding: 0 15px;
                    border: 2px solid #AEAEAE;
                    border-radius: 10px;
                    font-size: 16px;
                    &:focus {
                        border-color: #000;
                    }
                    @media screen and (max-width: 768px) {
                        flex: none;
                        width: 100%;
                    }
                }

                input[type="checkbox"] {
                    appearance: none;
                    width: 40px;
                    height: 40px;
                    border: 1px solid #787878;
                    border-radius: 7px;
                    position: relative;
                    margin-right: 20px;
                    cursor: pointer;
                    &:checked {
                        background-color: none;
                        &::after {
                            content: '✔';
                            color: #85D160;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 40px;
                        }
                    }
                }
                
                .form-group--checkbox {
                    display: flex;
                    align-items: flex-start;
                    .checkbox-container {
                        display: flex;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                    }
                }
            }

            button {
                height: 71px;
                width: 328px;
                max-width: 100%;
                background-color: var(--main-color);
                color: #fff;
                font-size: 25px;
                font-family: 'Font Regular';
                border: none;
                border-radius: 7px;
                cursor: pointer;

                &:hover {
                    background-color: #AEAEAE;
                }
            }
        }
    }
}
</style>
